import { useState, useEffect, useMemo, useRef } from "react";
import { filterServices, sortServices } from "../utils";
import { getBusinessDateParts } from "../../../utils/dateUtils";

export const useServiceFilters = (servicios, monthFilter, setMonthFilter) => {
  const [search, setSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [tecnicoFilter, setTecnicoFilter] = useState("");
  const [zonaFilter, setZonaFilter] = useState("");
  const [orderBy, setOrderBy] = useState("date");
  const [orderDirection, setOrderDirection] = useState("desc");
  const debounceRef = useRef(null);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => setSearchQuery(search), 300);
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [search]);

  const filtered = useMemo(() => {
    const result = filterServices(servicios, {
      search: searchQuery,
      tecnicoFilter,
      zonaFilter,
    });
    return sortServices(result, orderBy, orderDirection);
  }, [servicios, searchQuery, tecnicoFilter, zonaFilter, orderBy, orderDirection]);

  const resetFilters = () => {
    setSearch("");
    setSearchQuery("");
    setTecnicoFilter("");
    setZonaFilter("");
    const { year, month } = getBusinessDateParts();
    setMonthFilter(`${year}-${String(month + 1).padStart(2, "0")}`);
  };

  const goToPreviousMonth = () => {
    const [year, month] = monthFilter.split("-").map(Number);
    const date = new Date(year, month - 1, 1);
    date.setMonth(date.getMonth() - 1);
    const newYear = date.getFullYear();
    const newMonth = String(date.getMonth() + 1).padStart(2, "0");
    setMonthFilter(`${newYear}-${newMonth}`);
  };

  const goToNextMonth = () => {
    const [year, month] = monthFilter.split("-").map(Number);
    const date = new Date(year, month - 1, 1);
    date.setMonth(date.getMonth() + 1);
    const newYear = date.getFullYear();
    const newMonth = String(date.getMonth() + 1).padStart(2, "0");
    setMonthFilter(`${newYear}-${newMonth}`);
  };

  const handleSort = (column) => {
    if (orderBy === column) {
      setOrderDirection(orderDirection === "asc" ? "desc" : "asc");
    } else {
      setOrderBy(column);
      setOrderDirection("asc");
    }
  };

  const hasActiveFilters = Boolean(search || tecnicoFilter || zonaFilter);

  return {
    search,
    setSearch,
    tecnicoFilter,
    setTecnicoFilter,
    zonaFilter,
    setZonaFilter,
    monthFilter,
    setMonthFilter,
    goToPreviousMonth,
    goToNextMonth,
    filtered,
    resetFilters,
    orderBy,
    orderDirection,
    handleSort,
    hasActiveFilters,
  };
};
